import script from "./knowledgeManageDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./knowledgeManageDetail.vue?vue&type=script&setup=true&lang=js"

import "./knowledgeManageDetail.vue?vue&type=style&index=0&id=31f4b602&lang=css"
import "./knowledgeManageDetail.vue?vue&type=style&index=1&id=31f4b602&lang=less"
import "./knowledgeManageDetail.vue?vue&type=style&index=2&id=31f4b602&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31f4b602"]])

export default __exports__